import TYPES from "../consts";
export var isNavigation = function isNavigation(type) {
  return type === TYPES.NAVIGATION;
};
export var isInline = function isInline(type) {
  return type === TYPES.INLINE;
};